import {Component, EventEmitter, Input, Output, OnInit, ViewChild} from '@angular/core';
import { IPayoutRatesModel, PaymentTypeAlias, PaymentTypeAliasDisplayName } from 'app/common/models/coach-rate.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { CoachesService } from '../services/coaches.service';
import {AlertsService} from 'app/common/components/alerts/services/alerts.service';
import * as moment from 'moment';
import { ICourseModel } from 'app/common/models/course.model';
import { CoachesRateCalculateService } from '../services/coaches-rate-calculate.service';
@Component({
  selector: 'app-rate-element-edit',
  templateUrl: './rate-element-edit.component.html',
  styleUrls: ['./rate-element-edit.component.scss']
})
export class RateElementEditComponent implements OnInit {
  @Input() rate: IPayoutRatesModel;
  @Input() courses: Array<ICourseModel>;
  @Output() result = new EventEmitter<IPayoutRatesModel>();
  public form: FormGroup;
  private coursesValue: string = ''; 
  public personsRate: string = ''; 
  public classesRate: string = ''; 
  isOpenPersonRatePopup = false;
  isOpenClassRatePopup = false;
  constructor(
    protected coachesService: CoachesService,
    protected alertsService: AlertsService,
    private coachesRateCalculate: CoachesRateCalculateService
  ) { }

  ngOnInit() {
    this.coursesValue = this.rate.coursesIds;
    this.universalRateSetDetail(); 
    this.form = new FormGroup({
      paymentTypeAlias: new FormControl(this.rate.paymentTypeAlias, Validators.required),
      salary: new FormControl(this.rate.salary, Validators.required),
      personalClassRate: new FormControl(this.rate.personalClassRate, Validators.required),
      fixedClassRate: new FormControl(this.rate.fixedClassRate, Validators.required),
      personInGroupRate: new FormControl(this.rate.personInGroupRate, Validators.required),
      forUnlimitedRate: new FormControl(this.rate.forUnlimitedRate, Validators.required),
      subscriptionPercentRate: new FormControl(this.rate.subscriptionPercentRate, Validators.required),
      effectiveSinceDate: new FormControl(this.rate.effectiveSinceDate, [Validators.required]),
      classesRate: new FormControl(this.classesRate),
      personsRate: new FormControl(this.personsRate),
      selectedCourses: new FormControl('all', Validators.required),
    });

    // --- выключаем все контролы ---
    this.form.get('fixedClassRate').disable();
    this.form.get('personInGroupRate').disable();
    this.form.get('personalClassRate').disable();
    this.form.get('subscriptionPercentRate').disable();
    this.form.get('forUnlimitedRate').disable();
    this.form.get('classesRate').disable();
    this.form.get('personsRate').disable();
    if (this.form.get('paymentTypeAlias').value == PaymentTypeAlias.subscription)
    {
      this.form.get('subscriptionPercentRate').setValue(this.form.get('personInGroupRate').value);
      this.form.get('subscriptionPercentRate').enable();
      this.form.get('forUnlimitedRate').setValue(this.form.get('fixedClassRate').value);
      this.form.get('forUnlimitedRate').enable();
      this.form.get('personInGroupRate').setValue(0);
      this.form.get('personalClassRate').setValue(0);
      this.form.get('fixedClassRate').setValue(0);
    }
    if (this.form.get('paymentTypeAlias').value == PaymentTypeAlias.personInGroup)
    {
      this.form.get('personInGroupRate').enable();
      this.form.get('personalClassRate').enable();
    }
    if (this.form.get('paymentTypeAlias').value == PaymentTypeAlias.class){
      this.form.get('fixedClassRate').enable();
    }
    if (this.form.get('paymentTypeAlias').value == PaymentTypeAlias.pctWithoutMissed || this.form.get('paymentTypeAlias').value == PaymentTypeAlias.pctWithMissed){

      this.form.get('forUnlimitedRate').enable();
      this.form.get('forUnlimitedRate').setValue(this.form.get('forUnlimitedRate').value);
      this.form.get('subscriptionPercentRate').enable();
      this.form.get('subscriptionPercentRate').setValue(this.form.get('subscriptionPercentRate').value);

    }
    if (this.form.get('paymentTypeAlias').value == PaymentTypeAlias.progressiveRate){
      this.form.get('personsRate').enable();
      this.form.get('classesRate').enable();
    }
  }
  public truncatedRate(rate: string): string {
    const maxLength = 17; 
    return rate.length > maxLength 
      ? `${rate.substring(0, maxLength)}[...]` 
      : rate;
  }
  private universalRateSetDetail(){
    const universalRate = this.rate.universalRate;
    this.personsRate = this.rate.personInGroupRate;
    this.classesRate = this.rate.fixedClassRate
    
    if (this.rate.paymentTypeAlias == "progressiveRate" && universalRate) {
      [this.classesRate, this.personsRate] = universalRate.split('/');
    }
  }
  
  public async openRateConfig(popupType: 'person' | 'class') {
    if (popupType === 'person') {
      this.isOpenPersonRatePopup = true;
    } else {
      this.isOpenClassRatePopup = true;
    }
  }
  public async save(): Promise<any> {
    if (this.form.valid) {
      const defaultValue = "-";

      const personsRate = this.form.value.hasOwnProperty("personsRate") ? this.form.get('personsRate').value : "";
      const classesRate = this.form.value.hasOwnProperty("classesRate") ? this.form.get('classesRate').value : "";
      if (classesRate || personsRate) {
        this.rate.universalRate = `${classesRate}/${personsRate}`;
      }
      this.rate.coursesIds = this.coursesValue;
      this.rate.paymentTypeAlias = this.form.value.hasOwnProperty("paymentTypeAlias") ? this.form.get('paymentTypeAlias').value : defaultValue;
      this.rate.salary = this.form.value.hasOwnProperty("salary") ? this.form.get('salary').value : defaultValue;
      this.rate.personalClassRate = this.form.value.hasOwnProperty("personalClassRate") ? this.form.get('personalClassRate').value : defaultValue;
      this.rate.fixedClassRate = this.form.value.hasOwnProperty("fixedClassRate") ? this.form.get('fixedClassRate').value : defaultValue;
      this.rate.personInGroupRate = this.form.value.hasOwnProperty("personInGroupRate") ? this.form.get('personInGroupRate').value : defaultValue;
      this.rate.effectiveSinceDate = this.form.value.hasOwnProperty("effectiveSinceDate") ? this.form.get('effectiveSinceDate').value : defaultValue;
      this.rate.subscriptionPercentRate = this.form.value.hasOwnProperty("subscriptionPercentRate") ? this.form.get('subscriptionPercentRate').value: defaultValue;
      this.rate.forUnlimitedRate = this.form.value.hasOwnProperty("forUnlimitedRate") ? this.form.get('forUnlimitedRate').value : defaultValue;

      await this.saveRates();
      this.universalRateSetDetail(); 
    }
  }
  public onCoursesChange(coursesValue: Array<string>) {
    this.coursesValue = coursesValue.join(',');
  }
  public hasKey(key){
    if (this.rate.paymentTypeAlias == PaymentTypeAlias.class)
    {
      return key == 'fixedClassRate'; 
    }

    if (this.rate.paymentTypeAlias == PaymentTypeAlias.personInGroup)
    {
      return key == 'personInGroupRate'; 
    }

    if (this.rate.paymentTypeAlias == PaymentTypeAlias.subscription || 
      this.rate.paymentTypeAlias == PaymentTypeAlias.pctWithMissed || 
      this.rate.paymentTypeAlias == PaymentTypeAlias.pctWithoutMissed )
    {
      return key == 'subscriptionPercentRate' || key=='forUnlimitedRate'; 
    }
    if (this.rate.paymentTypeAlias == PaymentTypeAlias.progressiveRate) {
      return key == 'personsRate' || key=='classesRate'; 
    }
    
  }
  // public hasKey2(key: string): boolean {
  //   return this.form.value && this.form.value.hasOwnProperty(key);
  // }
  public dateFormat(date: Date): string {
    return moment(date).format('DD.MM.YYYY');
  }
  onRatesSaved(newRate: string, rateType: 'person' | 'class') {
    if (rateType === 'person') {
      this.personsRate = newRate;
      this.isOpenPersonRatePopup = false;
    } else {
      this.classesRate = newRate;
      this.isOpenClassRatePopup = false;
    }
    this.rate.paymentTypeAlias = this.form.value.hasOwnProperty("paymentTypeAlias") ? this.form.get('paymentTypeAlias').value : "";
    if (this.classesRate || this.personsRate) {
      this.rate.universalRate = `${this.classesRate}/${this.personsRate}`;
      this.saveRates();
    }
    else{
      console.error("Ошибка при сохранении");
    }
  }
  private async saveRates(){
    await this.coachesService.saveRate(this.rate).then(async (e) => {
      if (e) {
        this.rate.isEnableMode = false;
        this.result.emit(this.rate);
        this.alertsService.alert.next({
          type: 'success',
          message: 'Транзакция сохранена',
          header: 'Успех',
          position: 'top',
          timeout: 2000
        });
      } else {
        console.error(e);
      }
    });
    this.universalRateSetDetail(); 
  }
  public changeAlias(alias){
    if (alias == PaymentTypeAlias.class)
    {
      this.form.get('fixedClassRate').enable();
    }
    else
    {
      this.form.get('fixedClassRate').disable();
    }

    if (alias == PaymentTypeAlias.personInGroup)
    {
      this.form.get('personInGroupRate').enable();
      //this.form.get('personalClassRate').enable();
    }
    else
    {
      this.form.get('personInGroupRate').disable();
      //this.form.get('personalClassRate').disable();
    }

    if (alias == PaymentTypeAlias.subscription || alias == PaymentTypeAlias.pctWithMissed || alias == PaymentTypeAlias.pctWithoutMissed )
    {
      this.form.get('subscriptionPercentRate').enable();
      this.form.get('forUnlimitedRate').enable();
    }
    else
    {
      this.form.get('subscriptionPercentRate').disable();
      this.form.get('forUnlimitedRate').disable();
    }
    if (alias == PaymentTypeAlias.progressiveRate) {
      this.form.get('personsRate').enable();
      this.form.get('classesRate').enable();
    }
    else {
      this.form.get('personsRate').disable();
      this.form.get('classesRate').disable();
    }
    
  }
  public getTooltipInfoForClass(key: string): string {
    return this.coachesRateCalculate.tooltipInfo[key]
  }
  public readonly _PaymentTypeAliases = Object.keys(PaymentTypeAlias).filter(x => x !== 'subscription' && x !== 'withoutRate');
  public readonly PaymentTypeAliasDisplayName = PaymentTypeAliasDisplayName;
}
